import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "button", "icon"]

  connect() {
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', 'true')
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.add('rotate-180')
    }
    // Add event listener after a small delay to prevent immediate triggering
    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick)
    }, 100)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute('aria-expanded', 'false')
    }
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('rotate-180')
    }
    document.removeEventListener('click', this.handleOutsideClick)
  }

  handleOutsideClick(event) {
    // Close menu if click is outside dropdown
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
